import { Image } from "antd";
import React from "react";

import './index.sass';
import {MERCHANT_STATE} from "../../store/merchant";
import {connect} from "react-redux";
import {MERCHANT_CREATOR} from "../../config/Roles";
class UserInfo extends React.Component {
    constructor(props) {
        super(props);
        console.log(props)
        this.state = {
            rightBox: props.rightBox,
            userInfo: {}
        }
    }

    isSupper(roles) {
        return roles !== undefined ? roles.indexOf(MERCHANT_CREATOR) > -1 : false;
    }
    render() {
        let { rightBox} = this.state;
        const RightRender = () => {
            return rightBox ? rightBox : null;
        }
        return (
            <div className='userInfo'>
                {/*<p>首页/</p>*/}
                <div className='flex user_data'>
                    <div className='user_left flex'>

                        <div className='user_avatar'>
                            <Image src={this.props.merchant.avatar}/>
                        </div>
                        <div className='words'>
                            <p className='welcome'>{this.props.merchant.name}</p>
                            <div className='flex wish'>
                                <label>当前身份 | </label>
                                {this.isSupper(this.props.merchant.roles) ? (<p>超管</p>) : (<p>管理员</p>)}
                            </div>
                        </div>
                    </div>
                    <div className='user_right'>
                        <RightRender/>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (store) => {
    return {
        merchant: store[MERCHANT_STATE]
    }
};

export default connect(mapStateToProps)(UserInfo);